<template>
  <div>
    <div v-if="$service.isEdu(institute)">
      <div class="verification-individual col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">
            Institute Details
          </h4>
        </div>
        <div class="card-content row">

          <div v-for="notice in institute.notices" class="row col-sm-12">
            <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message" style="font-size: 130%">{{notice}}</span>
            </div>
          </div>

          <div v-if="institute.documents && institute.documents.length > 0">
            <div v-for="doc in institute.documents">
              <div v-if="doc.name == 'Institute Consent Form' || doc.type == 'CONSENT_INSTITUTE'" class="row col-sm-12">
                <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
                  <span data-notify="icon" class="fa fa-exclamation"></span>
                  <span data-notify="message" style="font-size: 130%">
                    Please ensure you use the specific Institute Consent Form required, otherwise your request <u>will</u> be rejected. 
                    Please <a v-bind:href="doc.template" style="color:black" target="_blank" download><u>download</u> <i class="fa fa-download" style="color:black"></i></a> and complete the specific consent form.
                  </span>
                </div>
              </div>
              <div v-if="doc.name.startsWith('Qualification Check Consent Form') || (doc.type != null && doc.type.startsWith('CONSENT_QC'))" class="row col-sm-12">
                <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
                  <span data-notify="icon" class="fa fa-exclamation"></span>
                  <span data-notify="message" style="font-size: 130%">
                    Please ensure you use the specific Qualification Check Consent Form required, otherwise your request <u>will</u> be rejected. 
                    Please <a v-bind:href="doc.template" style="color:black" target="_blank" download><u>download</u> <i class="fa fa-download" style="color:black"></i></a> and complete the specific consent form.
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!--
          <div v-if="institute.documents && institute.documents.length > 0" class="row col-sm-12">
            <div data-notify="container" class="col-md-12 alert alert-brand alert-with-icon ">
              <span data-notify="icon" class="fa fa-file-text-o"></span>
              <span data-notify="message" style="font-size: 130%">Before you begin, check you have the following documents, you will be required to upload them below:</span>
              <ol style="list-style-type: decimal;">
                <li v-for="notice in institute.documents" style="list-style-type: decimal">
                  {{notice.name}}
                  <ol>
                    <li v-if="notice.description" style="list-style-type: circle;">{{notice.description}}</li>
                    <li v-if="notice.template || notice.templateDescription" style="list-style-type: circle;">
                      <span v-if="notice.templateDescription">{{notice.templateDescription}}</span>
                      <span v-if="notice.template && notice.templateDescription"> : </span>
                      <span v-if="notice.template"><a v-bind:href="notice.template" style="color:white" target="_blank" download>Download <i class="fa fa-download" style="color:white"></i></a></span>
                    </li>
                  </ol>
                </li>
              </ol>
            </div>              
          </div>
          -->
          
          <div class="form-horizontal">

            <div class="form-group">
              <label class="col-sm-2 control-label">
                Institute 
              </label>
              <div class="col-sm-10 form-control-static">
                <div style="float: left">
                  <div v-if="institute.names && institute.names.length > 0">
                    <div v-for="name in institute.names">{{name.name}}</div>
                  </div>
                  <div v-else>{{institute.name}}</div>
                </div>
                <div style="float: left">
                  &nbsp;&nbsp;&nbsp;<button v-if="hasPermission($perms.IDV.DEL_INS)" @click.prevent="deleteInstitute" class="btn btn-default btn-xs">Change</button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                Country
              </label>
              <div class="col-sm-10 form-control-static">
                {{institute.region}}
              </div>
            </div>
            <div v-if="$store.getters.usesTokens" class="form-group">
              <label class="col-sm-2 control-label">
                Cost
              </label>
              <div class="col-sm-10 form-control-static">
                {{formatCreditTokens(institute.total)}} credit(s)
              </div>
            </div>
            <div v-else-if="pays && institute.product && hasPermission($perms.IDV.DEL_INS)" class="form-group">
                <label class="col-sm-2 control-label">
                  Price
                </label>
                <div class="col-sm-10 form-control-static" style="max-width: 400px">
                  Our Price
                  <span class="pull-right">
                   {{ formatMoney(institute.product.price) }}
                  </span>
                  <br />
                  Institute Surcharge
                  <span class="pull-right">
                    {{ formatMoney(institute.surcharge) }}
                  </span>
                  <br />
                  <div v-if="$store.state.accreditationEnabled">
                    Institute Accreditation Check
                    <span v-if="institute.accreditation">
                      <p-switch v-model="verification.accreditation" type="info" on-text="Yes" off-text="No"></p-switch>
                    </span>
                    <span v-else>
                      <el-tooltip content="Qualification Check does not support Accreditation checks for this institute.">
                        <i class="fa fa-question-circle-o " />
                      </el-tooltip>
                    </span>
                    <span class="pull-right">
                      <span v-if="institute.accreditation" :class="{ strikeThrough: !verification.accreditation }">
                        {{ formatMoney(institute.accreditation) }}
                      </span>
                      <span v-else>
                        -----
                      </span>
                    </span>
                  </div>
                  <hr />
                    Total
                    <span class="pull-right">
                    {{ formatMoney(institute.total + (verification.accreditation ? institute.accreditation : 0.0)) }}
                    </span>
                </div>
              </div>
            <div class="form-group" v-if="institute.documents.length > 0">
              <label class="col-sm-2 control-label">
                Required Documents
              </label>
              <span class="col-sm-10 form-control-static">
                <ol style="padding-left: 15px">
                  <li v-for="documents in institute.documents ">{{documents.name}}</li>
                </ol>
                <span class="help-block">
                  Ensure you have these documents to hand, you will need to upload them below.
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$service.isEmp(institute) || $service.isHSC(institute)">
      <div class="verification-individual col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">
            Country
          </h4>
        </div>
        <div class="card-content row">
          <div v-for="notice in institute.notices" class="row col-sm-12">
            <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message" style="font-size: 130%">{{notice}}</span>
            </div>
          </div>

          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">
                Country 
              </label>
              <div class="col-sm-10 form-control-static">
                <div style="float: left">
                  <div v-if="institute.names && institute.names.length > 0">
                    <div v-for="name in institute.names">{{name.name}}</div>
                  </div>
                  <div v-else>{{institute.name}}</div>
                </div>
                <div style="float: left">
                  &nbsp;&nbsp;&nbsp;<button v-if="hasPermission($perms.IDV.DEL_INS)" @click.prevent="deleteInstitute" class="btn btn-default btn-xs">Change</button>
                </div>
              </div>
            </div>
            <div v-if="$store.getters.usesTokens" class="form-group">
              <label class="col-sm-2 control-label">
                Cost
              </label>
              <div class="col-sm-10 form-control-static">
                {{formatCreditTokens(institute.total)}} credit(s)
              </div>
            </div>
            <div v-else-if="pays" class="form-group">
              <label class="col-sm-2 control-label">
                Price
              </label>
              <div class="col-sm-10 form-control-static" style="max-width: 300px">
                Our Price
                <span class="pull-right">
                 {{ formatMoney(institute.product.price) }}
                </span>
                <br />
                Institute Surcharge
                <span class="pull-right">
                  {{ formatMoney(institute.surcharge) }}
                </span>
                <br />
                <hr />
                  Total
                  <span class="pull-right">
                  {{ formatMoney(institute.total) }}
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="verification-individual col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Individual's Details</h4>
      </div>
      <div class="card-content row">
        <div class="form-horizontal">
          <div v-if="!multiScope && verification.new && previousNames != null && previousNames.length > 0" class="form-group">
            <label class="col-sm-2 control-label">Use a previous individual?</label>
            <div class="col-sm-10">
              <el-select v-model="previousName" 
                        :value="previousName"
                        placeholder="New Invdividual"
                        @change="copyName($event); previousName = $event"
                        value-key="full">
                <el-option key="-1" :value="null" label="New Individual" />
                <el-option v-for="name, index in previousNames" :key="name.full" :value="name" :label="name.firstname + ' ' + name.lastname" />
              </el-select>
            </div>
          </div>

          <dynamic-input name="firstname" label="First name" placeholder="First name" :description="nameDesc" v-model="verification.firstname" :validations="{required:true}" :validationScope="multiScope" :readOnly="!hasPermission($perms.IDV.UPD_FLD)" :hasPreviousCheck="true" />
          <dynamic-input name="middlename" label="Middle name" placeholder="Middle name" v-model="verification.middlename" :validationScope="multiScope" :readOnly="!hasPermission($perms.IDV.UPD_FLD)" />
          <dynamic-input name="lastname" label="Last name" placeholder="Last name" :description="nameDesc" v-model="verification.lastname" :validations="{required:true}" :validationScope="multiScope" :readOnly="!hasPermission($perms.IDV.UPD_FLD)" :hasPreviousCheck="true"/>
          <dynamic-input name="dob" label="Date of birth" placeholder="Date of birth" v-model="verification.dob" :validations="{required:true, date_format:'dd/MM/yyyy'}" type="DATE" :validationScope="multiScope" :readOnly="!hasPermission($perms.IDV.UPD_FLD)" :hasPreviousCheck="true"/>
          <dynamic-input v-if="institute && emailField" name="email" :label="emailField.label" :placeholder="emailField.label" v-model="emailField.value" :validations="$service.buildValidations(emailField)" :validationScope="multiScope" :readOnly="!hasPermission($perms.IDV.UPD_FLD)" :description="emailField.description" />
          <dynamic-input name="reference" v-if="application == null" :label="$store.getters.refLabel" placeholder="Reference" v-model="verification.customerReference" :validations="{required:$store.state.refRequired}" :validationScope="multiScope" :readOnly="!hasPermission($perms.IDV.UPD_FLD)" :description="!$store.state.refRequired ? 'The reference number used to track this case in your internal system if you have one.' : null" />
          
          <div v-if="previousVerificationData && previousVerificationData.size !== 0" class="verification-individual col-md-12">
            <h6>Previously Submitted Verifications:</h6>
            <div class="col-md-12 alert alert-warning alert-with-icon">
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message">It looks like you've submitted verifications for this individual at this institute before. Please avoid submitting duplicate verifications but remember you <b>DO</b> need to submit individual verifications for each degree or credential. Please see table below for details:</span>
            </div>
            <el-table
            :data="filteredVerifications"
            header="Previously Submitted Verifications"
            class="table table-striped table-no-bordered table-hover"
            highlight-current-row
            tooltip-effect="light"
          >
            <!-- Table columns -->
            <el-table-column prop="recorded" label="Date">
              <template slot-scope="{ row }">
                {{ formatDate(row.recorded) }}
              </template>
            </el-table-column>
            <el-table-column prop="fields" label="Name">
              <template slot-scope="{ row }">
                {{ row.fields.firstname + " " + row.fields.surname }}
              </template>
            </el-table-column>
            <el-table-column prop="instituteName" label="Institute Name"></el-table-column>
            <el-table-column prop="username" label="Requested By"></el-table-column>
            <el-table-column prop="result" label="Status" align="center">
              <template slot-scope="props">
                <span v-if="props.row.result === 'VERIFIED'" class="label label-wd label-plain text-success">
                  <i class="fa fa-check text-success"></i>Verified
                </span>
                <span v-else-if="props.row.result === 'NOT_VERIFIED'" class="label label-wd label-plain text-danger">
                  <i class="fa fa-times text-danger"></i>Not Verified
                </span>
                <span v-else-if="props.row.result === 'PENDING'" class="label label-wd label-plain">
                  <i class="fa fa-clock-o"></i>Pending
                </span>
                <span v-else-if="props.row.result === 'REJECTED'" class="label label-wd label-plain">
                  <i class="fa fa-exclamation"></i>Action Required
                </span>
                <span v-else-if="props.row.result === 'NOT_FOUND'" class="label label-wd label-plain">
                  <i class="fa fa-exclamation"></i>Action Required
                </span>
                <span v-else-if="props.row.result === 'UNPAID'" class="label label-wd label-plain">
                  <i class="fa fa-pencil"></i>Incomplete
                </span>
                <span v-else-if="props.row.result === 'AWAITING_CONSENT'" class="label label-wd label-plain">
                  <i class="fa fa-pencil"></i>Incomplete
                </span>
                <span v-else-if="props.row.result === 'CANCELLED'" class="label label-wd label-plain">
                  <i class="fa fa-times"></i>Cancelled
                </span>
                <span v-else-if="props.row.result === 'UNABLE'" class="label label-wd label-plain">
                  <i class="fa fa-clock-o"></i>Delayed at Source
                </span>
                <span v-else>
                  {{ props.row.result }}
                </span>
              </template>
          </el-table-column>
            <el-table-column width="80">
              <template slot-scope="{ row }">
                <a :href="getVerificationLink(row.id)" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i></a>
              </template>
            </el-table-column>
          </el-table>
      
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
      
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :page-size="pagination.perPage"
              :total="total"
              :perPage="5"
            ></p-pagination>
                </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in-linear" mode="out-in">

      <div key="SELECTED" v-if="institute">

        <!-- EDUCATION -->
        <div v-if="$service.isEdu(institute) || $service.isHSC(institute)" class="verification-individual col-md-12 card">
          <div class="card-header">
            <h4 class="card-title">
              Qualification Details
            </h4>
            <div v-if="this.$store.state.minYear" class="col-md-12 alert alert-warning alert-with-icon">
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message">{{institute.name}} requires the <b>'Year of Graduation / Issue'</b> to be set to <b>{{ this.$store.state.minYear }}</b> or later</span>
            </div>
          </div>  
          <div class="card-content row">
            <div class="form-horizontal">
                <!--
              <div v-if="this.application && this.application.owner.name == 'WES'" class="form-group">
                <label class="col-sm-2 control-label">
                  Level
                </label>
                <div class="col-sm-10 form-control-static">
                  <el-select v-model="qualType">
                    <el-option value="undergrad" label="Bachelor's degree (Undergraduate)" key="undergrad" />
                    <el-option value="masters" label="Master's degree (Graduate)" key="masters" />
                    <el-option value="phd" label="Doctoral degree (PhD)" key="phd" />
                    <el-option value="other" label="Other" key="other" />
                  </el-select>
                </div>
              </div>
                -->
              <div v-if="gotGradYear && allowsCurrent && !$service.isHSC(institute)" class="form-group">
                <label class="col-sm-2 control-label">
                  Enrolment Status 
                </label>
                <div class="col-sm-10 form-control-static">
                  <el-switch
                    v-model="currentStudent"
                    active-color="#3CA5AA"
                    inactive-color="#C3C3C3"
                    active-text="Current student"
                    inactive-text="Past student">
                  </el-switch>
                </div>
              </div>

              <dynamic-input 
                v-for="field in institute.fields"
                v-if="!(currentStudent && field.key == 'gradYear') && field.key != 'email'"
                :key="field.key"
                :name="field.key"
                :label="field.label" 
                :description="field.description"
                :placeholder="field.label" 
                v-model="field.value" 
                :validations="$service.buildValidations(field)"
                :validationScope="multiScope"
                :type="field.type"
                :refData="(field.refData == 'TRUE' || field.refData == 'ONLY')"
                :refDataValues="field.values ? field.values.map(value => {return {name: value}}) : null"
                :refDataInstituteId="institute.id"
                :refDataRestricted="field.refData == 'ONLY'"
                :readOnly="!hasPermission($perms.IDV.UPD_FLD)" />

              <!-- HIGH SCHOOL -->
              <div v-if="$service.isHSC(institute)" class="form-group">
                <label class="col-sm-2 control-label">
                  Courses / Subjects
                </label>
                <div class="col-sm-10 form-control-static">
                  <div class="row" style="padding-bottom: 10px" v-for="subject, index in verification.subjects">

                      <dynamic-input 
                        :key="'subjectsname'+(index+1)"
                        :name="'subjectsname'+(index+1)"
                        usePlaceholder="Course or Subject name" 
                        v-model="subject.name" 
                        :validationScope="multiScope"
                        :validateAs="'Course or Subject name '+(index+1)"
                        type="TEXT"
                        :readOnly="false"
                        :controlSize="9"
                        formGroupClass="no-form-group" />
                    <!-- :validations="$service.buildValidations({required: true})" USE THIS CODE TO MAKE ABOVE DYNAMIC-INPUT REQUIRED-->
                      <dynamic-input 
                        :key="'subjectsmark'+(index+1)"
                        :name="'subjectsmark'+(index+1)"
                        usePlaceholder="Grade or Mark (Actual or Predicted)"
                        v-model="subject.mark" 
                        :validationScope="multiScope"
                        :validateAs="'Grade or Mark '+(index+1)"
                        type="TEXT"
                        :readOnly="false"
                        :controlSize="2"
                        formGroupClass="no-form-group" />
                      <!-- :validations="$service.buildValidations({required: true})"  USE THIS CODE TO MAKE ABOVE DYNAMIC-INPUT REQUIRED-->
                    <button v-if="verification.subjects && verification.subjects.length > 1" class="btn btn-simple btn-info btn-icon btn-danger pull-right" @click.prevent="verification.subjects.splice(index, 1)"><i class="fa fa-trash"></i></button>
  
                  </div>
                  <button class="btn btn-fill" @click.prevent="verification.subjects.push({'name': null, 'mark': null})">Add another course / subject</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- EMPLOYER -->
        <div v-if="$service.isEmp(institute)" class="verification-individual col-md-12 card">
          <div class="card-header">
            <h4 class="card-title">
              Employer Details
            </h4>
          </div>
          <div class="card-content row">
            <div class="form-horizontal">
              <!-- NOTE THAT refDataValues relys on field.values.content (ie a page) rather than just a list of values -->
              <dynamic-input 
                v-for="field in institute.fields"
                v-if="field.key.startsWith('employer')"
                :key="field.key"
                :name="field.key"
                :label="field.label" 
                :description="field.description"
                :placeholder="field.label" 
                v-model="field.value" 
                :validations="$service.buildValidations(field)"
                :validationScope="multiScope"
                :type="field.type"
                :refData="(field.refData == 'TRUE' || field.refData == 'ONLY')"
                :refDataValues="(field.values && field.values.content) ? field.values.content : null"
                :refDataInstituteId="institute.id"
                :refDataRestricted="field.refData == 'ONLY'"
                :readOnly="!hasPermission($perms.IDV.UPD_FLD)" />
            </div>
          </div>
        </div>
        
        <!-- EMPLOYMENT + ALL ELSE -->
        <div v-if="$service.isEmp(institute.id)" class="verification-individual col-md-12 card">
          <div class="card-header">
            <h4 class="card-title">
              Employment Details
            </h4>
          </div>
          <div class="card-content row">
            <div class="form-horizontal">
              <!-- NOTE THAT refDataValues relys on field.values.content (ie a page) rather than just a list of values -->
              <dynamic-input 
                v-for="field in institute.fields"
                v-if="!field.key.startsWith('employer')"
                :key="field.key"
                :name="field.key"
                :label="field.label" 
                :description="field.description"
                :placeholder="field.label" 
                v-model="field.value" 
                :validations="$service.buildValidations(field)"
                :validationScope="multiScope"
                :type="field.type"
                :refData="(field.refData == 'TRUE' || field.refData == 'ONLY')"
                :refDataValues="(field.values && field.values.content) ? field.values.content : null"
                :refDataInstituteId="institute.id"
                :refDataRestricted="field.refData == 'ONLY'"
                :readOnly="!hasPermission($perms.IDV.UPD_FLD)" />
            </div>
          </div>
        </div>
        
        <div v-if="canAddDoc || (institute && institute.documents && institute.documents.length > 0)" class="verification-individual col-md-12 card">
          <div class="card-header">
            <h4 class="card-title">Documents</h4>
            <div class="category">Mandatory documents that are required by the {{$service.isEmp(institute.id) ? 'organisation' : 'institute'}} in order to process a verification are marked with a asterisk below.<span v-if="additionalDocsAllowed > 0"> You can also use "Add another document" to add any further documentation you feel might be useful.</span> <b>(Must be pdf file type)</b></div>
          </div>
          <div class="card-content row">
            <document-card 
              v-for="document, index in institute.documents" 
              v-if="!document.output"
              :key="index" 
              :document="document"
              :deleteData="documentDeleteData" 
              @deleted="removeDocument(index)"
              :canAdd="hasPermission($perms.IDV.ADD_DOC)"
              :canDelete="hasPermission($perms.IDV.DEL_DOC)"
              :validationScope="multiScope"
              :mustDownload="$store.state.isIndividual && document.type && document.type.startsWith('CONSENT')" />
              
            <div v-if="canAddDoc && phdStudent">
              <document-card :document="phdDocument"/>
            </div>
            <div v-if="canAddDoc" @click.prevent="addDocument">
              <document-card :document="fakeDocument" />
            </div>
          <!--
            <div v-if="verification.new && hasPermission($perms.IDV.SAV_LTR)">
              <div class="col-sm-12">
                <button @click.prevent="$emit('saveForLater', verification)" type="submit" class="btn btn-icon"><i class="fa fa-save"></i>&nbsp;Save for later</button>
                <span class="help-block">
                  Don't have the documents to hand? You can save this verification now and retieve it from your history later.</br>
                </span>
              </div>
            </div>            
          -->
          </div>
        </div>
      </div>

      <div key="SEARCH" v-else>
        <institute-select
          :previousInstitutes="previousInstitutes"
          @select="selectInstitute($event)" />
      </div>
      </transition>

      <slot name="actions" :verification="verification" :valid="verificationValid" />

  </div>
</template>

<script>
  import InstituteSelect from 'src/views/Verifications/components/InstituteSelect'
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import DocumentInput from 'src/views/Verifications/components/DocumentInput'
  import DocumentCard from 'src/views/Verifications/components/DocumentCard'
  import { mapState } from 'vuex';
  import ModalUploader from 'src/components/ModalPlugin/ModalUploader'
  import moment from 'moment'
  import PSwitch from 'src/components/Switch.vue'
  import PPagination from "src/components/Pagination.vue";

  import accounting from 'accounting'

  accounting.settings.currency.symbol = "£";

  export default {
    name: "verification",
    components: {
      InstituteSelect,
      DynamicInput,
      DocumentInput,
      DocumentCard,
      PPagination,
      PSwitch
    },
    inject: ['$validator'],
    props: {
      verification: { type: Object, default() {
        return {
            firstname: null,
            middlename: null,
            lastname: null,
            dob: null,
            institute: null,
            customerReference: null,
            new: true,
            accreditation: false
          } 
        }
      },
      additionalDocsAllowed: { type: Number, default: 5},
      permissions: { type: Number, default: 0 },
      previousNames: { type: Array },
      previousInstitutes: { type: Array },
      documentDeleteData: { type: Function },
      application: {type: Object, default() {
        return null
      }},
      multiScope: {type: String, default: ''}
    },
    data() {
      return {
        qualType: "undergrad",
        previousName: null,
        currentStudent: false,
        pagination: {
          perPage: 5,
          currentPage: 1,
          total: 0
        },
      }
    },
    computed: {
      paginationCurrentPage() {
      return this.pagination.currentPage;
    },
    paginationPerPag() {
      return this.pagination.perPage;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
      ...mapState(['previousVerificationData']),
      filteredVerifications() {
        if (!this.previousVerificationData) {
          return [];
        }
        this.total = this.previousVerificationData.content.length;
        const from = (this.pagination.currentPage - 1) * this.pagination.perPage;
        const to = from + this.pagination.perPage;
        return this.previousVerificationData.content.slice(from, to);
      },
      institute() {
        return this.verification.institute
      },
      pays() {
        if(this.application && !this.application.applicantPays) {
          return false
        } else {
          return (this.$store.state.paymentType == 'CARD' || this.$store.state.paymentType == 'INVOICE')
        }
      },
      verificationValid() {
        if(!this.verification.institute) {
          return false
        }
        if(this.$validator.errors.any()) {
          return false
        }
        return true
      },
      additionalDocsLeft() {
        var docsLeft = this.additionalDocsAllowed
        if(this.institute.documents && this.institute.documents.length > 0) {
          this.institute.documents.forEach(doc => {
            if(!doc.required) {
              docsLeft--
            }
          })
        }
        return docsLeft
      },
      canAddDoc() {
        var canAdd = this.additionalDocsLeft >= 1
        if(this.institute.documents && this.institute.documents.length > 0) {
          this.institute.documents.forEach(doc => {
            if(!doc.required && doc.id == null && doc.data == null) {
              canAdd = false
              return
            }
          })
        }
        return canAdd
      },
      gotGradYear() {
        var result = false
        if(this.institute) {
          this.institute.fields.forEach(field => {
            if(field.key == 'gradYear') {
              result = true
              return
            }
          })
        }
        return result
      },
      emailField() {
        var result = null
        if(this.institute) {
          this.institute.fields.forEach(field => {
            if(field.key == 'email') {
              result = field
              if(this.$store.state.isIndividual) {
                result.value = this.$store.state.username
              }
            }
          })
        }
        return result
      },
      allowsCurrent() {
        var result = true
        if(this.institute) {
          if(this.institute.id == 'H60UniofHud') { // TODO make this an API config option
            result = false
          }
        }
        return result
      },
      phdDocument() {
        return {
          "fake": false,
          "name": "Doctoral Degree Confirmation",
          "description": "Please attach your Doctoral Degree (PhD) Confirmation as additional evidence.",
          "required": true
        }
      },
      fakeDocument() {
        return {
          "fake": true,
          "name": "Add another document",
          "description": "Optionally attach up to " + this.additionalDocsLeft + " additional documents as supporting evidence.",
          "templateDescription": this.institute.documents && this.institute.documents.length <= 0 ? "Note that attaching documents will skip automatic checking and your request will go for manual checking immediately." : null
        }
      },
      phdStudent() {
        return this.qualType == 'phd'
      },
      nameDesc() {
        var desc = 'Must be the name used at the time of study, as shown on the diploma/certificate. Please check to ensure the name has not changed since the time of study, for example due to marriage.'
        if(this.$service.isEmp(this.institute)) {
          desc = 'Must be the name used at the time of employment.'
        }
        if(this.$service.isId(this.institute)) {
          desc = 'Must be the full name as printed on the identity document.'
        }
        return desc
      }
    },
    watch: {
      currentStudent(value) {
        if(this.institute.fields.find(f => f.key == 'gradYear')) {
          this.institute.fields.find(f => f.key == 'gradYear').value = value ? "-1" : null
        }
      }
    },
    mounted() {
      this.currentStudent = this.institute != null && this.institute.fields.find(f => f.key == 'gradYear')
          && (this.institute.fields.find(f => f.key == 'gradYear').value == '-1' 
                || this.institute.fields.find(f => f.key == 'gradYear').value == '1___')
    },
    methods: {
      getVerificationLink(id) {
        return `#/verification/history/${id}`;
      },
      formatDate(timestamp) {
        var m = moment(timestamp)
        return m.format('DD/MM/YYYY')
      },
      copyName(name) {
        if(name)  {
          this.verification.firstname = name.firstname
          this.verification.middlename = name.middlename
          this.verification.lastname = name.lastname
          this.verification.dob = name.dob
        } else {
          this.verification.firstname = null
          this.verification.middlename = null
          this.verification.lastname = null
          this.verification.dob = null
        }
      },
      selectInstitute(institute) {
        this.verification.institute = institute
      },
      deleteInstitute() {
        this.currentStudent = false
        this.$emit('deleteInstitute')
      },
      hasPermission(permission) {
        return this.$perms.hasPermission(this.permissions, permission)
      },
      formatMoney(amount, addedAmount) {
        if(addedAmount) {
          return accounting.formatMoney(amount)
        }
        return accounting.formatMoney(amount)
      },
      formatCreditTokens(value) {
        if(this.$store.state.paymentType == 'TOKEN_SINGLE_CREDIT') {
          value = 1
        }
        return accounting.formatMoney(value, '', 0)
      },
      addDocument() {
        this.$modal.show(ModalUploader,
              {
                title: "Add Document",
                message: "Please enter a short label describing your document.",
                closeText: "Cancel",
                action: (value, filename, base64Data) => 
                  {
                    this.institute.documents.push({
                      id: null,
                      filename: filename,
                      data: base64Data,
                      required: false,
                      name: value,
                      verificationId: this.verification.id
                    })
                    this.$modal.close()
                  }
              })

      },
      removeDocument(index) {
        this.institute.documents.splice(index, 1)
      }
    }
  }
</script>

<style scoped>

hr {
  border-top: 1px dashed;
  background-color: transparent;
}

.strikeThrough {
  text-decoration: line-through;
}

</style>